/**
 * Public site layout — maksimum içerik genişliği 1280px, mobilde tam genişlik.
 */
export const SITE_MAX_WIDTH_PX = 1280

export const SITE_MAX = 'max-w-[1280px]' as const

/** Mobil yatay iç boşluk — px-1 yerine px-2 (kenarlara yapışmayı önler) */
export const SITE_PAD_X = 'px-2 sm:px-4 md:px-5' as const

/** 320px dar ekranlarda yatay taşmayı azaltır; safe-area header’da ayrıca eklenir */
export const SITE_CONTAINER = `mx-auto w-full min-w-0 ${SITE_MAX} ${SITE_PAD_X}` as const

export const SITE_MAIN_PAD_Y = 'py-4 sm:py-5 md:py-6' as const

export const SITE_PAGE_BG = 'min-h-screen min-w-0 max-w-full bg-white dark:bg-slate-950' as const

/** Header iç satırı — SITE_MAX + safe-area yatay padding */
export const SITE_HEADER_ROW =
  `mx-auto flex h-full w-full min-w-0 ${SITE_MAX} items-center gap-1.5 sm:gap-2 md:gap-3` as const

export const SITE_SHELL_TOP = 'pt-14 md:pt-[4.125rem]' as const
export const SITE_SHELL_TOP_STRIP = 'pt-24 md:pt-[6.625rem]' as const

export const SECTION_HEADER_ROW =
  'mb-6 flex min-w-0 flex-col gap-3 sm:flex-row sm:items-center sm:justify-between' as const

/** Wing reklamlar header altında yapışırken içerikle hizalanma boşluğu */
export const AD_WING_STICKY_GAP_PX = 8

/** 160×600 skyscraper — içerik kolonunun hemen yanında (1280 + 160×2) */
export const AD_SKYSCRAPER_WIDTH_PX = 160
export const AD_SKYSCRAPER_MIN_VIEWPORT_PX = 1600
/** Tailwind JIT — sabit string olmalı (template literal ile üretilmez) */
export const AD_SKYSCRAPER_SHOW_CLASS = 'hidden min-[1600px]:flex' as const
export const AD_SKYSCRAPER_SLOT_SHOW_CLASS =
  'hidden min-[1600px]:block min-[2260px]:hidden' as const

/** 490×1080 pageskin — ultra geniş ekran (1280 + 490×2) */
export const AD_PAGESKIN_WIDTH_PX = 490
export const AD_PAGESKIN_MIN_VIEWPORT_PX = 2260
export const AD_PAGESKIN_SHOW_CLASS = 'hidden min-[2260px]:block' as const
